import { Component, OnInit, ViewChild } from '@angular/core';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm } from '@angular/forms';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ResetButtonRendererComponent } from 'src/app/resetbutton-renderer.component';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Createproject } from 'src/app/model/createproject.model';
import { ExportButtonRendererComponent } from 'src/app/exportbutton-renderer.component';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'app-projectinfo',
  templateUrl: './projectinfo.component.html',
  styleUrls: ['./projectinfo.component.css']
})
export class ProjectinfoComponent implements OnInit {
  test1: string;
  customMessage: any;
  test: string;
  projectDetails: any;
  ckeditorContent: string;
  multipleBool: boolean = false;
  roleId: string;
  isSurveyDataExist: boolean = false;
  remainUnassignedLinks: number = 0;
  isVendorDetailsExist: boolean = false;
  rowData: any;
  rowDataForMultiple: any;
  rowDataNew: any;
  private gridApi;
  private gridColumnApi;
  project: Createproject;
  frameworkComponents: any
  isDataLoading: boolean = false;

  columnDefs = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Survey Link", field: "clientLink", resizable: true },
    { headerName: "Target", field: "target", resizable: true, maxWidth: 120, editable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", resizable: true, maxWidth: 130, editable: true },
    {
      headerName: 'Re-set Target',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.ResetData.bind(this),
        label: 'Reset'
      },
    },

  ];

  columnDefsForMultiple = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true },
    { headerName: "Target", field: "target", resizable: true, editable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", resizable: true, editable: true },
    {
      headerName: 'Re-set Target',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.ResetData.bind(this),
        label: 'Reset'
      },
    },
    {
      headerName: 'Export',
      cellRenderer: 'exportButtonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.exportLinksMultiple.bind(this),
        label: 'Export'
      },
    },

  ];

  columnDefsNew = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Vendor Name", field: "vendorName", resizable: true, maxWidth: 138 },
    { headerName: "Assigned Clip(s)", field: "assignedClip", resizable: true, maxWidth: 120 },
    {
      headerName: "SurveyRedirectionDetails",
      cellRenderer: function (param) {
        return '<b>' + param.data.tag1 + '</b>' + '<br/>' + param.data.exevoLink + '<br/>' + '<b>' + param.data.tag2 + '</b>' + '<br/>' + '<b>' + param.data.tag3 + '</b>' + '<br/>' + param.data.vendorSC + '<br/>' + '<b>' + param.data.tag4 + '</b>' + '<br/>' + param.data.vendorST + '<br/>' + '<b>' + param.data.tag5 + '</b>' + '<br/>' + param.data.vendorSQF + '<br/>' + '<b>' + param.data.tag6 + '</b>' + '<br/>' + param.data.vendorSQCR;
      }
    },
    {
      headerName: 'Edit Country Check',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.editCountryCheck.bind(this),
        label: 'Reset'
      },
    },
  ];

  columnDefsMultiple = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Vendor Name", field: "vendorName", resizable: true, maxWidth: 138 },
    { headerName: "Assigned Clip(s)", field: "assignedClip", resizable: true, maxWidth: 120 },
    {
      headerName: "SurveyRedirectionDetails",
      cellRenderer: function (param) {
        return '<b>' + param.data.tag3 + '</b>' + '<br/>' + param.data.vendorSC + '<br/>' + '<b>' + param.data.tag4 + '</b>' + '<br/>' + param.data.vendorST + '<br/>' + '<b>' + param.data.tag5 + '</b>' + '<br/>' + param.data.vendorSQF + '<br/>' + '<b>' + param.data.tag6 + '</b>' + '<br/>' + param.data.vendorSQCR;
      }
    },
    { headerName: "Assigned No.Of Links", field: "assignedLinks", resizable: true, maxWidth: 120 },
    {
      headerName: 'Edit Country Check',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.editCountryCheck.bind(this),
        label: 'Reset'
      },
    },
    {
      headerName: 'Export',
      cellRenderer: 'exportButtonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.exportLinks.bind(this),
        label: 'Export'
      },
    },

  ];
  rowHeight = 300;

  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };

  constructor(private userService: UserService, private router: Router, private roleservice: RoleService, private route: ActivatedRoute, private toastr: ToastrService) {
    this.roleId = this.route.snapshot.params.projectid;
    this.frameworkComponents = {
      buttonRenderer: ResetButtonRendererComponent,
      exportButtonRenderer: ExportButtonRendererComponent,
    }
  }

  ngOnInit() {
    //alert(this.roleId);
    this.getProjectInfo();
    // this.getSurveyLinkData();
    this.getVendorDetailsData();
    this.project = new Createproject();
  }

  getProjectInfo() {
    debugger;
    this.roleservice.SearchProjectInfo(this.roleId).subscribe(
      (data: any) => {
        if (data != null || data != undefined) {


          if (data[0].projectMode == "Production") {
            data[0].projectMode = "2";
          }
          else if (data[0].projectMode == "Staging" || data[0].projectMode == "Testing") {
            data[0].projectMode = "1";
          }
          this.customMessage = data[0].customPageMessage

          this.projectDetails = data;
          if (this.projectDetails.filter(s => s.clintLinkType == "multiple").length > 0) {
            this.multipleBool = true;
          }
          else {
            this.multipleBool = false;
          }
        }

        if (this.projectDetails.length === 0) {
        }
        else {


        }
        this.getSurveyLinkData();
        console.log(this.projectDetails);
      }
    )
  }

  exportLinks(param) {
    this.roleservice.exportLinks(param).subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
          const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          this.saveAsExcelFile(excelBuffer, "Encrypted Links");
        }
      });
  }

  getSurveyLinkData() {
    if (!this.multipleBool) {
      this.roleservice.GetSurveyLinkData(this.roleId).subscribe(
        (data: any) => {
          debugger;
          if (data.length != 0) {
            this.isSurveyDataExist = true;
            this.rowData = data;
          }
          else {
            this.isSurveyDataExist = false;
          }
        }
      )
    }
    else if (this.multipleBool) {
      this.roleservice.GetSurveyLinkDataForMultiple(this.roleId).subscribe(
        (data: any) => {
          debugger;
          if (data.length != 0) {
            this.isSurveyDataExist = false;
            this.rowDataForMultiple = data;
          }
          else {

          }
        }
      )
    }
  }

  getVendorDetailsData() {
    debugger;
    this.roleservice.GetVendorDetailsData(this.roleId).subscribe(
      (data: any) => {
        this.rowDataNew = data;
        console.log(this.rowDataNew)
        if (data.length != 0) {
          debugger;
          this.isVendorDetailsExist = true;
          debugger;
          if (this.multipleBool) {
            for (var i = 0; i < this.rowDataNew.length; i++) {
              this.remainUnassignedLinks += this.rowDataNew[i].remainingLinks;
            }
          }
        }
        else {
          this.isVendorDetailsExist = false;
        }
      }
    )
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  AddCountry() {
    this.router.navigate(['/createproject/' + this.roleId + "/" + this.projectDetails[0].projectName + "/" + this.projectDetails[0].clientName + "/" + this.projectDetails[0].projectDescription]);
  }

  AddLanguage() {
    this.router.navigate(['/createproject/' + this.roleId + "/" + this.projectDetails[0].projectName + "/" + this.projectDetails[0].clientName + "/" + this.projectDetails[0].projectDescription]);
  }

  ResetData(params) {
    debugger;
    if (!this.multipleBool) {
      this.isDataLoading = true;
      this.userService.ResetData(params.data, this.roleId).subscribe(
        (data) => {
          this.isDataLoading = false;
          if (data == true) {
            this.toastr.success("Data Reset Successfully", '', { progressBar: true });
          }
          else {
            this.toastr.warning("Some Error Occurred", '', { progressBar: true });
          }
        }
      )
    }
    else if (this.multipleBool) {
      this.isDataLoading = true;
      this.userService.ResetDataForMultiple(params.data, this.roleId).subscribe(
        (data) => {
          this.isDataLoading = false;
          if (data == true) {
            this.toastr.success("Data Reset Successfully", '', { progressBar: true });
          }
          else {
            this.toastr.warning("Some Error Occurred", '', { progressBar: true });
          }
        }
      )
    }
  }

  editCountryCheck(param) {
    this.userService.editcountrychecks(param.data.projectId, param.data.countryId, param.data.languageId)
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          console.log("data:", data);
          this.project.ipsecurity = data[0].isIPEnabled;
          this.project.custompage = data[0].isCustomPageEnabled;
          this.project.geoiplocation = data[0].isGeoIPLocationEnabled;
          this.project.fingerprintsecurity = data[0].isFingerPrintEnabled;
          this.project.questionnaire = data[0].questionnaire;
          this.project.recaptcha = data[0].recaptcha;
          this.project.mobile = data[0].mobile;
          this.project.projectid = data[0].projectID;
          this.project.languageid = data[0].languageID;
          this.project.countryid = data[0].countryID;
          //this.project.invisiblerecaptcha = data[0].invisiblerecaptcha;
           debugger;
          console.log("Project",this.project);
        }
      });
    $("#myModal").show();
  }
  closeDialog() {
    $("#myModal").hide();
  }

  OnSubmit(form: NgForm) {
    debugger;
    form.value.projectid = this.roleId;
    console.log(form.value);
    if (form.value.projectMode == "1") {
      form.value.projectMode = "Staging";
    }
    else if (form.value.projectMode == "2") {
      form.value.projectMode = "Production";
    }
    else if (form.value.projectMode == "3") {
      form.value.projectMode = "Fieldwork Closed";
    }

    this.userService.updateProjectStatus(form.value)
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          this.userService.updateProjectLog(form.value)
            .subscribe((data: any) => {
            });
          this.toastr.success("Project Status Updated", '', { progressBar: true });
        }
      });
  }

  EditCountryCheck() {
    console.log("After edit", this.project);
    this.userService.updateCountryCheck(this.project)
      .subscribe((data: any) => {
        if (data) {
          this.toastr.success("Checks Updated Successfully", '', { progressBar: true });
          this.closeDialog();
        }
        else {
          this.toastr.error("Error Occurred", '', { progressBar: true });
          this.closeDialog();
        }
      });
  }

  exportLinksMultiple(param) {
    this.userService.getMultipleLinkDataToExport(param.data, this.roleId)
      .subscribe((data: any) => {
        if (data) {
          this.DownloadExcel(data);
        }
        else {
          this.toastr.error("No Data To Export", '', { progressBar: true });
        }
      });
  }

  DownloadExcel(data: any) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, "Multiple Links");
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    fileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}

